import React from 'react'

export const RicercaProdottoCardSectionSettings = (settingsProps) => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  )
}
